import React from 'react';
import { Chart } from 'react-google-charts';
import WrapperCard from './WrapperCard';

const options = {
  legend: { position: 'bottom', alignment: 'start' },
  chartArea: {
    left: 40,
    right: 15,
    top: 10,
    bottom: 50,
  },
  series: [{ color: '#0077b6' }],
  pointsVisible: true,
  hAxis: {
    minorGridlines: { count: 0 }
  },
  vAxis: {
    format: 'short',
  }
};

function Usage({ isLoading, data }) {
  const totalUsage = data?.total_usage || [];

  const chartData = React.useMemo(() => {
    if (!totalUsage?.length) {
      return [];
    }

    const preparedArray = totalUsage.map(t => {
      const minutes = parseInt(t.total_minutes.value, 10);

      return [{ v: t.key_as_string, f: t.key_as_string }, minutes];
    });

    return [['Date', 'Minutes'], ...preparedArray];
  }, [totalUsage]);

  return (
    <WrapperCard
      isLoading={isLoading}
      title="Usage (Minutes)"
      contentSkeletons={6}
      headerTooltip="Total minutes for all calls across all lines for the last 7 days"
    >
      {chartData?.length ? (
        <Chart chartType="AreaChart" width="100%" height="249px" data={chartData} options={options} />
      ) : (
        <div style={{ textAlign: 'center', padding: '20px' }}>No data available</div>
      )}
    </WrapperCard>
  );
}

export default Usage;
